/*
 * @Author: your name
 * @Date: 2021-01-19 12:14:20
 * @LastEditTime: 2021-10-11 13:56:04
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \lavrock-official-platform\src\store\modules\kindEditor.js
 */
import _ from 'lodash'
import KindEditorApi from '../../api/kind.editor.api'
const state = {
	uploadImgData: [],
	imgUploadType: 'add', // add添加 modify 修改
	uploadFileData: {},
	fileUploadType: 'add', // add添加 modify 修改
}

const getters = {}

const mutations = {
	SET_UPLOAD_IMG_DATA (state, data) {
		state.uploadImgData = data
	},
	SET_IMG_UPLOAD_TYPE (state, data) {
		state.imgUploadType = data
	},
	SET_UPLOAD_FILE_DATA (state, data) {
		state.uploadFileData = data
	},
	SET_FILE_UPLOAD_TYPE (state, data) {
		state.fileUploadType = data
	}
}

const actions = {
	saveUserPage (context, data) {
		console.log(context)
		return KindEditorApi.saveUserPage(data)
	}
}

export default {
	state, getters, mutations, actions, namespaced: true
}
